import { useMutation } from '@apollo/client';
import SAVE_OBSERVATION_ACTION from '../queries/saveObservationActionMutation';
import { useNavigate } from 'react-router-dom';
import { showSuccessToast } from '@shared/services/toastService';
import { EVENT_APPRAISER_ASSIGNMENT_STATUS } from '../components/shared/constants';

const previousLink = '/calendar';

const useSaveObservationAction = eventId => {
  const navigate = useNavigate();

  const [saveObservationAction, { error: saveObservationActionError }] =
    useMutation(SAVE_OBSERVATION_ACTION);

  const handleSaveObservationAction = async status => {
    const actionMessage =
      status === EVENT_APPRAISER_ASSIGNMENT_STATUS.ACCEPTED ? 'accepted' : 'rejected';

    await saveObservationAction({
      variables: {
        assignmentData: {
          EventId: eventId,
          Status: status
        }
      }
    });

    showSuccessToast(`Observation ${actionMessage} successfully.`);

    if (status === EVENT_APPRAISER_ASSIGNMENT_STATUS.REJECTED) {
      navigate(previousLink);
    }
  };

  return {
    handleSaveObservationAction,
    error: saveObservationActionError
  };
};

export default useSaveObservationAction;
